import { render, staticRenderFns } from "./Casaspad.vue?vue&type=template&id=47b702d0"
import script from "./Casaspad.vue?vue&type=script&lang=js"
export * from "./Casaspad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports